/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import intl from 'react-intl-universal';

import {scoreDecimals, toCompactAmount} from "../../helpers/IspScoreHelper";
import {linkForIsp} from "../LinkHelper";
import ScoreIndicator from "../../components/ScoreIndicator";

class IspSmallCard extends Component {

    shouldShowRank() {
        return this.props.rank > 0;
    }

    render() {
        const isp = this.props.isp;
        const show = this.props.show ? this.props.show : 0;
        return this.renderIspCard(isp, show);
    }

    renderIspCard(isp, show) {
        const logoUrl = isp.logoImageUrl;
        return (
            <div className="card card-frame transition-3d-hover mb-3">
                <Link className="card-body" to={linkForIsp(isp)}>
                    {this.renderRank()}
                    <div className="media">
                        <div className="avatar">
                            <img className="img-fluid" src={logoUrl} alt={isp.name + " logo"}/>
                        </div>
                        <div className="media-body px-4">
                            <h4 className="h6 text-dark mb-1">{isp.name}</h4>
                            {this.renderMetricIndicator(isp, show)}
                        </div>
                    </div>
                </Link>
            </div>
        );
    }

    renderMetricIndicator(isp, show) {
        switch (show) {
            case 0:
                const scoreValue = isp.ispScore.scoreValue;
                let score = scoreDecimals(scoreValue / (100.0 / 5), 1);
                return [
                    <ScoreIndicator key='score_indicator' score={scoreValue}/>,
                    <span key='score_value' className="font-weight-semi-bold ml-2 text-body">{score}</span>
                ];
            case 1:
                const sentimentValue = isp.ispSentiment.sentimentValue;
                let sentiment = scoreDecimals(sentimentValue / (100.0 / 5), 1);
                return [
                    <ScoreIndicator score={sentimentValue}
                                    fullClass="fas fa-heart"
                                    halfClass="fas fa-heart"
                                    emptyClass="far fa-heart" />,
                    <span className="font-weight-semi-bold ml-2 text-body">{sentiment}</span>
                ];
            case 2:
                const sampleValue = isp.ispScore.samples;
                return [
                    <span className="text-secondary">{intl.get('scoreboard_samples_amount', {amount: toCompactAmount(sampleValue)})}</span>
                ];
            default:
                return '';
        }

    }

    renderRank() {
        if (!this.shouldShowRank())
            return;

        const rank = this.props.rank;
        return (
            <div className="float-right small text-muted">
                #{rank}
            </div>
        );
    }

}

export default IspSmallCard;